import { render, staticRenderFns } from "./DataOutflow.vue?vue&type=template&id=cab552e4&scoped=true&"
import script from "./DataOutflow.vue?vue&type=script&lang=js&"
export * from "./DataOutflow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cab552e4",
  null
  
)

export default component.exports